import { Box, Fade } from "@mui/material";
import { FullContainer } from "../../components/FullContainer";
import DialogCharacter from "./components/DialogCharacter";
import { DialogFader } from "./components/DialogFader";
import DialogText from "./components/DialogText";
import { useDialogData } from "./context/DialogProvider";

export const DialogsModule = () => {
  console.info("DialogsModule render");

  //  CONTEXTS
  const { showDialog } = useDialogData();

  return showDialog ? (
    <Fade in={showDialog} appear>
      <FullContainer>
        {/* background */}
        <DialogFader />
        {/* bottom container */}
        <Box sx={{ position: "absolute", bottom: "0px", width: "100%" }}>
          {/* text and next button */}
          <DialogText />
          {/* character visual */}
          <DialogCharacter />
        </Box>
      </FullContainer>
    </Fade>
  ) : (
    <></>
  );
};
